export type UseSettingsPreferences = {
  state: Ref<any>;
  hasPreferences: ComputedRef<boolean>;
  preferences: ComputedRef<MemberPreferences[]>;
};

export const INJECT_SETTINGS_PREFERENCES = Symbol(
  'useSettingsPreferences composable'
) as InjectionKey<UseSettingsPreferences>;

export const useSettingsPreferences = () => {
  const profile = useProfileStore();

  const preferences = computed(() => profile.memberPreferences);

  const profileLoadFromNetwork = useProfileLoadFromNetwork();

  const hasPreferences = computed(
    () => Object.keys(preferences.value).length > 0
  );

  const state = ref<any>({});

  const update = async () => {
    let request = await useApiFetch(URI.UpdatePreferences, {
      method: 'POST',
      body: { ...state.value },
    });
    if (request.error) return false;
    request = await profileLoadFromNetwork.run();
    if (request.error) return false;
    return true;
  };

  const debouncedRequest = useDebounceFn(async () => {
    const result = await update();
    return result;
  }, 500);

  watchEffect(() => {
    Object.keys(preferences.value).forEach((key) => {
      state.value[key] = preferences.value[key];
    });
  });

  watch(
    () => state.value,
    async (newValue) => {
      globalThis.$logger.info('useSettingsPreferences :: state', newValue);
      await debouncedRequest();
    },
    { deep: true }
  );

  return {
    hasPreferences,
    preferences,
    state,
  };
};
